angular.module('storefrontApp')

.component('vcReviewStar', {
    templateUrl: "themes/assets/js/products-list/review-star.tpl.html",
    bindings: {
        onClick: '=',
        size: '=',
        rating: '=',
        reviewsCount: '=',
        textCount : '='
    },
    controller: function () {

        //$(document).ready(function () {
        //    $(".starSelect").click(function (e) {
        //        e.preventDefault();
        //        var star = $(this).attr("href");
        //        SelectStar(star);
        //        { { onClick } } (star);
        //    });
        //});

        //this.SelectStar = function (star) {
        //    var intStar = parseInt(star);
        //    var yellowStar = $(".yellowStar");
        //    yellowStar.width(Math.round(intStar / 5.0 * 100.0, 0) + "%");
        //}
    }
});
